// extracted by mini-css-extract-plugin
module.exports = {"Scenarios":"Scenarios_Scenarios__2Ieyz","ef-box":"Scenarios_ef-box__NN_0V"};